
import React from "react";
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "@/components/ui/collapsible";
import { ChevronRight } from "lucide-react";

interface CollapsibleSectionProps {
  title: string;
  count: number;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  sectionId: string;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  count,
  isOpen,
  onToggle,
  children,
  sectionId
}) => {
  const contentId = `section-content-${sectionId}`;
  
  return (
    <div className="border-b border-mono-slateGray/30 last:border-b-0">
      <Collapsible open={isOpen} onOpenChange={onToggle}>
        <CollapsibleTrigger asChild>
          <button
            className="w-full px-3 py-2 flex items-center justify-between bg-mono-outerSpace/50 hover:bg-mono-outerSpace/70 transition-colors focus:outline-none"
            aria-expanded={isOpen}
            aria-controls={contentId}
            type="button"
          >
            <span className="text-sm font-medium text-mono-seasalt">
              {title} <span className="text-xs font-light">({count})</span>
            </span>
            <ChevronRight
              className={`h-4 w-4 text-mono-seasalt transition-transform duration-200 ${
                isOpen ? 'rotate-90' : ''
              }`}
            />
          </button>
        </CollapsibleTrigger>
        <CollapsibleContent 
          id={contentId}
          forceMount
          className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
        >
          <div className={`${isOpen ? 'block' : 'hidden'}`}>
            {children}
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

export default CollapsibleSection;
